import styled, { css } from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

export const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  ${({ theme: { spacing } }) => css`
    padding: 0 ${spacing.level6};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: ${spacing.level5} ${spacing.level4};
    `}
    flex: none;
    justify-content: flex-start;
    align-items: stretch;
  }
`;
